import styled from 'styled-components';
import { LIGHT_LAVENDER, VIOLET_800 } from '@styles/colors';
import { GIVONIC } from '@styles/fonts';
import LightGradientBackground from '@assets/images/LightGradientBackground.png';

export const Container = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    background-image: url(${LightGradientBackground});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 16px;
`;

export const HeaderContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px 16px 16px 16px;
`;

export const AssetLabel = styled.span`
    font-family: ${GIVONIC.regular};
    font-size: 14px;
    color: ${VIOLET_800};
`;

export const Divider = styled.div`
    width: 100%;
    height: 2px;
    background-color: ${LIGHT_LAVENDER};
`;

export const ActionButtonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 16px 24px;
`;

export const ActionButtonSkeletonContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0 12px;
`;

export const ActionButtonSkeletonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
`;

export const ActionButtonsWrapper = styled.div<{ $onlyTwoButtons?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: ${({ $onlyTwoButtons }) => $onlyTwoButtons ? 'space-evenly' : 'space-between'};
    width: 100%;
`;
